import { AgentInLenderContext } from '@nemuru-eng/js-api-client';

import { PlatformCredentialField } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/types/CredentialFieldConfig';

const hasNonEmptyString = (value: string | null | undefined) => value != null && value.trim() !== '';

export const hasChannelOrAgentInLenderContext = (agentInLenderContext?: AgentInLenderContext) =>
  hasNonEmptyString(agentInLenderContext?.channelIdInLenderContext) ||
  hasNonEmptyString(agentInLenderContext?.agentIdInLenderContext);

export const isStoredCredentialField = (
  platformField: PlatformCredentialField,
  agentInLenderContext?: AgentInLenderContext,
) => {
  if (!agentInLenderContext) {
    return false;
  }

  switch (platformField) {
    case 'username':
      return agentInLenderContext.hasUsername;
    case 'password':
      return agentInLenderContext.hasPassword;
    case 'clientId':
      return agentInLenderContext.hasClientId;
    case 'clientSecret':
      return agentInLenderContext.hasClientSecret;
    case 'merchantIdInLenderContext':
      return hasNonEmptyString(agentInLenderContext.merchantIdInLenderContext);
    case 'channelIdInLenderContext':
      return hasNonEmptyString(agentInLenderContext.channelIdInLenderContext);
    case 'agentIdInLenderContext':
      return hasNonEmptyString(agentInLenderContext.agentIdInLenderContext);
    case 'market':
      return hasNonEmptyString(agentInLenderContext.market);
    default:
      return false;
  }
};
